module.exports = __webpack_public_path__ + "static/media/landing.a36a759f.png";